import { getComponentsConfig } from '@/biz/apis/config.api'
import { fxCur } from '@/utils/env'
import { RuntimeConfigProvider } from '@nio-wad/config-provider'
import { BASE_API, fetch as fetchFn } from '@/utils/fetch'
import { getCommonParams } from '@/config/base'
import { Fetch } from '@loca/mfe-utils'

export const registerConfig = async () => {
  const fxId = (process.config as any).fxId
  // 获取配置
  RuntimeConfigProvider.register(() => {
    // FX 异步获取环境配置  兜底使用，可没有
    const fxConfigs = fetch(
      `https://static.nio.com/fx-static/${fxId}/fixed/nsh5.${fxCur}.json?t=${Date.now()}`,
    )
      .then((r) => r.json())
      .then((json) => {
        const config: any = {}
        const cp = json?.components
        if (cp?.length < 1) return {}
        cp.forEach((el: { id: string | number; name: any; show: any; properties: any }) => {
          config[el.id] = {
            name: el.name,
            show: el.show,
            properties: el.properties,
          }
        })
        return config
      })
      .catch(() => {
        console.log('获取FX配置失败')
      })
    const polarisConfigsPromise = async () => {
      let { res, config } = await getComponentsConfig()
      if (res && res.resultCode === 'Authorization Failed') {
        // 如果因为设备判断问题导致的鉴权错误，修改公共参数client为pc再试一次
        fetchFn.setGenFetch(
          Fetch.genFetch(BASE_API, {
            commonParams: getCommonParams('pc'),
            needAuth: true,
          }),
        )
        config = (await getComponentsConfig()).config
      }
      return Promise.resolve(config)
    }
    return Promise.all([fxConfigs, polarisConfigsPromise()]).then((configs) => {
      const fxConfig = configs[0] || {}
      const polarisConfig = configs[1] || {}
      const mergedConfig = {
        ...fxConfig,
        ...polarisConfig,
      }
      console.log('====================================')
      console.log('获取FX配置', fxConfig)
      console.log('获取北极星配置', polarisConfig)
      console.log('合并配置', mergedConfig)
      console.log('====================================')
      return mergedConfig
    })
  }, 'nsh5')
}
